// Meldingen onderaan het scherm, zoals in het prototype: kort, en met Ongedaan maken als dat kan.
import { createContext, useCallback, useContext, useRef, useState, type ReactNode } from "react";
import { Icon } from "../lib/icons";

interface Toast { text: string; undo?: () => void; error?: boolean }
const Ctx = createContext<{ flash: (text: string, opts?: { undo?: () => void; error?: boolean }) => void }>({ flash: () => {} });

export function ToastProvider({ children }: { children: ReactNode }) {
  const [toast, setToast] = useState<Toast | null>(null);
  const timer = useRef<number>(0);
  const flash = useCallback((text: string, opts: { undo?: () => void; error?: boolean } = {}) => {
    window.clearTimeout(timer.current);
    setToast({ text, ...opts });
    timer.current = window.setTimeout(() => setToast(null), opts.undo ? 6000 : opts.error ? 8000 : 2600);
  }, []);
  return (
    <Ctx.Provider value={{ flash }}>
      {children}
      {toast && (
        <div className={"p-toast" + (toast.error ? " err" : "")} role="status">
          <Icon name={toast.error ? "alert" : "check"} size={16} />
          {toast.text}
          {toast.undo && (
            <button type="button" className="p-toast-undo" onClick={() => { window.clearTimeout(timer.current); setToast(null); toast.undo!(); }}>Ongedaan maken</button>
          )}
        </div>
      )}
    </Ctx.Provider>
  );
}

export const useToast = () => useContext(Ctx);
